import { useState, useEffect } from 'react'

const C = { amber: '#B8721F', border: '#DDD4C6', brown: '#2C1D14', muted: '#9A7B68', bg: '#F2EDE4' }

export default function Input({
  value,
  onChange,
  onBlur,
  onFocus,
  placeholder,
  type = 'text',
  label,
  style,
  autoComplete,
  autoCapitalize = 'sentences',
  autoCorrect = 'off',
  spellCheck = 'false',
  required,
  disabled,
  multiline,
  rows = 3,
  ...props
}) {
  const [localValue, setLocalValue] = useState(value ?? '')
  const [isFocused, setIsFocused] = useState(false)

  useEffect(() => {
    setLocalValue(value ?? '')
  }, [value])

  const baseStyle = {
    width: '100%',
    padding: '12px 16px',
    borderRadius: '8px',
    border: `1px solid ${isFocused ? C.amber : C.border}`,
    background: C.bg,
    fontFamily: 'Calibri, sans-serif',
    fontSize: '16px',
    color: C.brown,
    boxSizing: 'border-box',
    WebkitUserSelect: 'text',
    userSelect: 'text',
    touchAction: 'manipulation',
    outline: 'none',
    WebkitAppearance: 'none',
    appearance: 'none',
    transition: 'border-color 0.15s',
    ...style,
  }

  const handleChange = (e) => {
    setLocalValue(e.target.value)
    // Don't call parent onChange on every keystroke — only on blur
    // This prevents parent re-renders that cause iOS focus loss
  }

  const handleFocus = (e) => {
    setIsFocused(true)
    if (onFocus) onFocus(e)
  }

  const handleBlur = (e) => {
    setIsFocused(false)
    if (onChange) onChange(e.target.value)
    if (onBlur) onBlur(e.target.value, e)
  }

  const lbl = {
    fontSize: '10px', color: C.muted, letterSpacing: '1.5px',
    textTransform: 'uppercase', fontFamily: 'Calibri, sans-serif',
    display: 'block', marginBottom: '5px',
  }

  if (multiline) {
    return (
      <div>
        {label && <label style={lbl}>{label}{required && ' *'}</label>}
        <textarea
          value={localValue}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          placeholder={placeholder}
          rows={rows}
          disabled={disabled}
          style={{ ...baseStyle, resize: 'vertical', minHeight: '80px' }}
          {...props}
        />
      </div>
    )
  }

  return (
    <div>
      {label && <label style={lbl}>{label}{required && ' *'}</label>}
      <input
        type={type}
        value={localValue}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        placeholder={placeholder}
        disabled={disabled}
        autoComplete={autoComplete}
        autoCorrect={autoCorrect}
        autoCapitalize={autoCapitalize}
        spellCheck={spellCheck}
        style={baseStyle}
        {...props}
      />
    </div>
  )
}
